/**
 * Created by zcr on 2018/1/25.
 */

let proxySource = {
    "/productionApi": "https://production.com/",
    "/devapi": "https://test.com/",
  },
  proxyRoot = [];
for (let key in proxySource) {
  // proxyTarget.push(proxySource[key]);
  //生产环境取域名 其他取对应key
  proxyRoot.push(
    process.env.NODE_ENV === "production" ? proxySource[key] : key + "/"
  );
}

module.exports = {
  prefix: "bigscreenTemplate_", //项目前缀
  xAppVersion: "1.0.0", //版本
  base_path: "", //  项目地址
  proxySource: proxySource, //代理源配置
  root: proxyRoot, // 配置API接口地址
  proxyUrl: {
    defult: "AdminTemplate/public/index.php",
  },
  publicKey: "LTAI4GKXdB0hcaFS78629b526a153b17",

  isTest: true, //是否测试环境
};
